import React from 'react';
import Modal from '@mui/material/Modal';
import { IoIosClose } from 'react-icons/io';

import * as S from './styles';
import { color } from 'styles/pallete';
import { ContainerModalProps } from 'types/ContainerModalProps';
import { useTranslation } from 'react-i18next';

// Explicação das props está em: types/containerModalProps
export default function ContainerModal({
	isOpenProps = false,
	setIsOpenModal,
	children,
	title,
	buttonClose = true,
	buttonText = 'understood',
	colorButton = color.interface.lightBlue2,
	functionBtn,
	paddingChildren = true
}: ContainerModalProps) {
	const { t }: any = useTranslation();

	return isOpenProps ? (
		<Modal
			open={isOpenProps}
			onClose={setIsOpenModal}
			style={{ border: 'unset' }}
		>
			<S.container>
				<S.content>
					<IoIosClose
						data-testid="modal-x-btn"
						onClick={() => setIsOpenModal(false)}
						style={{
							color: color.interface.darkgray2,
							fontSize: '25px',
							cursor: 'pointer'
						}}
					/>
					{typeof title !== 'undefined' && (
						<>
							<S.title>
								<p title={title}>{title}</p>
							</S.title>
							<S.line />
						</>
					)}

					{children && (
						<S.childrenWithProps paddingChildren={paddingChildren}>
							{children}
						</S.childrenWithProps>
					)}

					{buttonClose && (
						<>
							<S.line />
							<S.buttonsWithProps colorBtn={colorButton}>
								<button
									data-testid={`${title}-buttonText`}
									onClick={() => {
										setIsOpenModal(!isOpenProps);
										if (typeof functionBtn === 'function') functionBtn();
									}}
								>
									{t(`${buttonText}`)}
								</button>
							</S.buttonsWithProps>
						</>
					)}
				</S.content>
			</S.container>
		</Modal>
	) : null;
}
